__webpack_require__.p = "/tkn_lnd_pg/_next/";